<template>
  <div class="mt-4">
    <div class="text-xs-center">
      <span
        style="
          padding: 0px 20px;
          background-color: black;
          border-radius: 10px;
          color: white;
          font-size: 24px;
        "
        >Cancelled</span
      >
      <v-btn icon :loading="isLoading" @click="fetchDataList()">
        <v-icon>refresh</v-icon></v-btn
      >
    </div>
    <v-layout wrap row class="mt-4">
      <!-- <v-flex sm6 xs12
        ><v-menu
          ref="menu1"
          v-model="menu1"
          :close-on-content-click="false"
          :nudge-right="40"
          :return-value.sync="date_start"
          lazy
          transition="scale-transition"
          offset-y
          full-width
          min-width="290px"
        >
          <template v-slot:activator="{ on }">
            <v-text-field
              v-model="date_start"
              label="Select date start"
              prepend-icon="event"
              readonly
              v-on="on"
            ></v-text-field>
          </template>
          <v-date-picker
            @change="
              $refs.menu1.save(date_start), (menu1 = false), fetchDataList()
            "
            v-model="date_start"
            no-title
            scrollable
          >
          </v-date-picker>
        </v-menu>
      </v-flex> -->
      <v-spacer></v-spacer>
      <v-flex sm6 xs12
        ><v-menu
          ref="menu2"
          v-model="menu2"
          :close-on-content-click="false"
          :nudge-right="40"
          :return-value.sync="date_end"
          lazy
          transition="scale-transition"
          offset-y
          full-width
          min-width="290px"
        >
          <template v-slot:activator="{ on }">
            <v-text-field
              v-model="date_end"
              label="Select date"
              prepend-icon="event"
              readonly
              v-on="on"
            ></v-text-field>
          </template>
          <v-date-picker
            @change="
              $refs.menu2.save(date_end), (menu2 = false), fetchDataList()
            "
            v-model="date_end"
            no-title
            scrollable
          >
          </v-date-picker>
        </v-menu>
      </v-flex>
    </v-layout>
    <OrderWesmartTable
      :isLoading="isLoading"
      class="mt-4"
      :headers="tableHeaders"
      :items="order_wesmart_list_4"
      @toEdit="toEdit($event)"
    ></OrderWesmartTable>
  </div>
</template>

<script>
import OrderWesmartTable from "@/components/back-office/OrderWesmart/OrderWesmartTable.vue";
import { mapActions, mapState } from "vuex";
export default {
  data() {
    return {
      isLoading: true,
      tableHeaders: [
        {
          text: "#",
          align: "center",
          value: "product_code",
          sortable: false,
        },
        {
          text: "Code",
          align: "center",
          value: "order_code",
          sortable: false,
        },

        {
          text: "Type",
          align: "center",
          value: "order_type",
          sortable: false,
        },
        {
          text: "Total Price",
          align: "center",
          value: "orders_total_price",
          sortable: false,
        },
        {
          text: "Date/Time Start",
          align: "center",
          value: "action",
          sortable: false,
        },
        {
          text: "Date/Time End",
          align: "center",
          value: "action",
          sortable: false,
        },
        {
          text: "",
          align: "center",
          value: "action",
          sortable: false,
        },
      ],
      date_start: new Date().toISOString().substr(0, 10),
      date_end: new Date().toISOString().substr(0, 10),
      menu1: false,
      menu2: false,
    };
  },
  components: {
    OrderWesmartTable,
  },
  computed: {
    ...mapState({
      order_wesmart_list_4: (state) =>
        state.fetchOrderListBack.order_wesmart_list_4,
    }),

    orderListByStatus() {
      return this.order_wesmart_list_4;
    },
  },
  methods: {
    ...mapActions({
      fetchOrderList: "fetchOrderListBack/fetchOrderWesmartList",
    }),
    async fetchDataList() {
      this.isLoading = true;
      let payload = {
        status: 4,
        province: this.$route.params.province,
        date_start_end: `${this.date_end},${this.date_end}`,
      };
      await this.fetchOrderList(payload);
      this.isLoading = false;
    },
    toEdit(orderId) {
      this.$router.push({
        path: `/weserve_admin_login/orderwesmart/${this.$route.params.province}/orderlist/${orderId}`,
      });
    },
  },
  created() {
    this.$store.commit("fetchOrderListBack/setOrderWesmartList", {
      data: [],
      status: 4,
    });
    this.fetchDataList();
  },
};
</script>

<style lang="scss" scoped>
</style>